import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Link } from "react-router-dom";
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";
import { useSelector, useDispatch } from "react-redux";


const api = axios.create({
    baseURL: 'InventoryMasterDetails'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})

export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
    {
        id: "12345678",
        firstName: "0001-HFHJS",
        lastName: "16.5",
        emailId: "sriyanka",
        phone: "9/01/2023  10:12:23",

    }
];


export default function UpdateSlipInventory(props) {
    //const classes = useStyles();

    //for progress
    var columns = [
        { title: "Slip Number", field: "id" },
        { title: "Location", field: "firstName" },
        { title: "Entered Quantity", field: "lastName" },
        { title: "Entered By", field: "emailId" },
        { title: "Entered On", field: "phone" },

    ];

    const [openLoader, setopenLoader] = useState(false);

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");
    const [alertwarningclass, setalertwarningclass] = useState("bg-amber clr-white");
    const [alertwarning, setalertwarning] = useState("Warning");

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');
    const [canShowHelperText, setCanShowHelperText] = useState(false);

    //Autocomplete
    const [employeeObj, setEmployeeObj] = useState('');
    const [employeeText, setEmployeeText] = useState('');

    const handleChangeEmployee = (event, newValue) => {
       // console.log(newValue);
        setEmployeeObj(newValue ? newValue : []);
        setEmployeeText(newValue ? newValue.empName : "");
        setemployeeValue(newValue ? newValue.employeeId : 0);
    };
    const handleChangeEmployeeInput = (event, newInputValue) => {
        setEmployeeText(newInputValue ? newInputValue : " ");
    };

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function handleCloseWarning() {
        setopenWarning(false);
    }

    //function getURLParameter(sParam) {
    //    var sPageURL = window.location.search.substring(1);
    //    var sURLVariables = sPageURL.split('&');
    //    for (var i = 0; i < sURLVariables.length; i++) {
    //        var sParameterName = sURLVariables[i].split('=');
    //        var value = '';
    //        for (var j = 0; j < sParameterName.length; j++) {
    //            if (sParameterName[j] == sParam) {
    //                for (var k = j + 1; k < sParameterName.length; k++) {
    //                    value = value + sParameterName[k];
    //                }
    //                break;
    //            }
    //            else {
    //                continue;
    //            }
    //        }
    //        return value;
    //    }       
    //}
    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 25, 50],
        paginationPosition: "bottom",
        //paging: false,
        maxBodyHeight: '600px',
        // exportButton: true,
        // exportAllData: true
    };
    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [isDisabled, setisDisabled] = useState(true);
    const [employee, setemployee] = useState([]);
    const [employeeValue, setemployeeValue] = useState("");
    //const [employeeNameValue, setEmployeeNameValue] = useState("");
    //const [employeeNames, setEmployeeNames] = useState([]);
    const [mrp, setmrp] = useState([]);
    const [time, settime] = useState([]);
    const [date, setdate] = useState([]);
    const [mrpValue, setmrpValue] = useState('');
    const [shiftValue, setshiftValue] = useState('');
    //const [slipGenId, setslipGenId] = useState(window.atob(getURLParameter("ID")) ? window.atob(getURLParameter("ID")) : props.SlipGenId);
    const [EntryNumberValue, setEntryNumberValue] = useState("");
    const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
    const [WorkerShift, setWorkerShift] = useState([]);
    const [EnteredTimeValue, setEnteredTimeValue] = useState("");
    const [InputTimeValue, setInputTimeValue] = useState("");
    const [IdleTimeValue, setIdleTimeValue] = useState("");
    const [EfficiencyValue, setEfficiencyValue] = useState("");
    const [slipDataDetails, setslipDataDetails] = useState([]);
    const [slipDataPlanTime, setslipDataPlanTime] = useState([]);
    const [slipDataUnPlanTime, setslipDataUnPlanTime] = useState([]);
    const [slipDataIHFTime, setslipDataIHFTime] = useState([]);
    const [PlanTimeValue, setPlanTimeValue] = useState([]);
    const [UnPlanTimeValue, setUnPlanTimeValue] = useState([]);
    const [IHFTimeValue, setIHFTimeValue] = useState([]);
    const [NoWorkValue, setNoWorkValue] = useState(0);
   // const [CreatedBy, setCreatedBy] = useState(props.loginuser.firstName + ' ' + props.loginuser.lastName);
    //const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.employeeId);
    const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
    const [ViewEfficiencyValue, setViewEfficiencyValue] = useState("");
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    //const [alertsuccess, setalertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    //new
    const [Remarks, setRemarks] = useState("");
    const [place, setPlace] = useState([]);
    const [placeValue, setPlaceValue] = useState("");
    const [loc, setLoc] = useState("");
    const [matNo, setMatNo] = useState("");
    const [matDesc, setMatDesc] = useState("");
    const [classification, setClassification] = useState("");
    const [unit, setUnit] = useState("");
    const [physical, setPhysical] = useState("");
    const [dateOfEntry, setdateOfEntry] = useState("");
    const [slipNumber, setslipNumber] = useState("");
    const [enteredByUser, setEnteredByUser] = useState("");
    const [phyInvlocation, setphyInvlocation] = useState([]);
    const [phyInvlocationName, setphyInvlocationName] = useState('');
    const [phyInvlocationID, setphyInvlocationID] = useState('');
    const [phyInvlocationObj, setphyInvlocationObj] = useState('');
    const [phyInvMaterial, setphyInvMaterial] = useState([]);
    const [phyInvMaterialName, setphyInvMaterialName] = useState('');
    const [phyInvMaterialID, setphyInvMaterialID] = useState('');
    const [phyInvMaterialObj, setphyInvMaterialObj] = useState('');
    const [phyInvWorkflow, setphyInvWorkflow] = useState('');
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    
    //new handles
    const handlePlace = (event) => {
        setPlaceValue(event.target.value);
    }
    const handleslipNumber = (event) => {
        setslipNumber(event.target.value);
    }
    
    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    };
    const handledateOfEntryChange = (event) => {
        setdateOfEntry(event.target.value);
    };
    const handleLoc = (event) => {
        setLoc(event.target.value);
    }
    const handleMatNo = (event) => {
        setMatNo(event.target.value);
    }
    const handleMatDesc = (event) => {
        setMatDesc(event.target.value);
    }
    const handleClassification = (event) => {
        setClassification(event.target.value);
    }
    const handleUnit = (event) => {
        setUnit(event.target.value);
    }
    const handlePhysical = (event) => {
        //setPhysical(event.target.value);       
                
        const regexp = /^(([0-9]{0,7})(\.[0-9]{0,5})?|10000000)$/;
        if (event.target.value === '' || regexp.test(event.target.value)) {
            setCanShowHelperText(true);
            setPhysical(event.target.value);
        }
        else {
            setCanShowHelperText(false);
        }
    }
    const handleEnteredByUser = (event) => {
        setEnteredByUser(event.target.value);
    }
    
    //const handleChangeEmp = (event) => {
    //    setemployeeValue(event.target.value);
    //};

    const handleChangeMrp = (event) => {
        setmrpValue(event.target.value);
    };

    const handleChangeShift = (event) => {
        setshiftValue(event.target.value);
    };













    function calculateEfficiency_manual(enteredTimeValue, inputTimeValue, idleTimeValue, noWorkValue) {
        //let idletime = ((inputTimeValue - idleTimeValue) + noWorkValue);
        let idletime = inputTimeValue - idleTimeValue - noWorkValue;
        let efficiency = 0;
        if (inputTimeValue > idleTimeValue) {
            efficiency = enteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }

    function calculateEfficiency() {
        //let idletime = ((InputTimeValue - IdleTimeValue) + NoWorkValue);
        let idletime = InputTimeValue - IdleTimeValue - NoWorkValue;
        let efficiency = 0;
        if (InputTimeValue > IdleTimeValue) {
            efficiency = EnteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }


    function handleClose() {
        setopen(false);
    }


    function backClick() {
        props.clickgoback(null);
    }

    //NEW FUNCS
    function clear() {
        setphyInvlocationName("");
        setphyInvlocationID("");
        setphyInvlocationObj("");
        setphyInvMaterialName("");
        setphyInvMaterialID("");
        setphyInvMaterialObj("");
        setPhysical("");
        setRemarks("");
    }

    useEffect(async () => {
       // console.log("props", props);
        if (props.Mode == "edit") {
            await BindMaterialDetails(props.editData);
            await setState(props.editData);
            await BindLocation(props.editData);

        }
    }, []);
    async function setState(rowData) {
      //  console.log(rowData);
        setslipNumber(rowData.slipnumber);
        setPlaceValue(rowData.plantname);
        setMatDesc(rowData.materialDescription);
        setPhysical(rowData.countedPhyQuantity);
        setClassification(rowData.abcclassiification);
        setUnit(rowData.unitOfMeasurement);
        setdateOfEntry(rowData.createdDate);
        setEnteredByUser(rowData.slipCreatedBy);
        setRemarks(rowData.remarks);
       
        //setphyInvlocationObj(phyInvlocationObj);
    }

    async function BindLocation(rowData) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        await api.get('/getPhyInvLocation/' + rowData.plantId,{
            headers: headers,
        })
            .then(res => {
                let locData = [];
                setphyInvlocation(res.data);
                locData = res.data;
                locData.filter(x => x.locationId == rowData.locationId).map(filtered => {
                  //  console.log("filtered",filtered);
                    setphyInvlocationObj(filtered);
                    setphyInvlocationName(filtered ? filtered.locationName : "");
                    setphyInvlocationID(filtered ? filtered.locationId : 0);
                });
                setopenLoader(false);
            })
            .catch(error => {
                setopenLoader(false);
                console.log("Error in hitting api at page load. PhyInvLocation")
            })
    }
    const handleChangephyInvlocation = async (event, newValue) => {
       // console.log("newValue", newValue);
        setphyInvlocationObj(newValue ? newValue : []);
        setphyInvlocationName(newValue ? newValue.locationName : "");
        setphyInvlocationID(newValue ? newValue.locationId : 0);
        //await BindMaterialDetails(placeValue);
        //if (newValue != null)
        //    await BindMaterialDetails(newValue.locationId, placeValue);
        //else
        //    await ClearMaterialDetails();

    };
    const handleChangephyInvlocationInput = (event, newInputValue) => {
        setphyInvlocationName(newInputValue ? newInputValue : "");
    };

    async function BindMaterialDetails(rowData) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let PhyInvInputData = {
            plantId: Number(rowData.plantId),
        }

        await api.post('/GetPhyInvMaterialNo/', PhyInvInputData, { headers: headers})
            .then(res => {
                let materialData = [];
                setphyInvMaterial(res.data);
                materialData = res.data;
                materialData.filter(x => x.materialId == rowData.materialId).map(filtered => {
                   // console.log("Material filtered", filtered);
                    setphyInvMaterialObj(filtered);
                    setphyInvMaterialName(filtered ? filtered.materialName : "");
                    setphyInvMaterialID(filtered ? filtered.materialId : 0);
                });
               // console.log("MaterialDetails", res.data);
                setopenLoader(false);


            })
            .catch(error => {
                console.log("Error in hitting api at page load. PhyInvLocation");
                setopenLoader(false);

            })
    }
    const handleChangephyInvMaterial = async (event, newValue) => {
        setphyInvMaterialObj(newValue ? newValue : []);
        setphyInvMaterialName(newValue ? newValue.materialName : "");
        setphyInvMaterialID(newValue ? newValue.materialId : 0);

    };
    const handleChangephyInvMaterialInput = (event, newInputValue) => {
        setphyInvMaterialName(newInputValue ? newInputValue : "");
    };
    function UpdateSlip() {
        let isValidate = true;
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = [];
        if (phyInvlocationID == "" || phyInvlocationID === null || phyInvlocationID === undefined) {
            isValidate = false;
            errorList.push("Select Location Name");
            showMessage(errorList, true, 'error');
        }
        if (physical == "" || physical === null || physical === undefined) {
            isValidate = false;
            errorList.push("Enter Counted Physical Quantity");
            showMessage(errorList, true, 'error');
        }
        if (phyInvMaterialID == "" || phyInvMaterialID === null || phyInvMaterialID === undefined) {
            isValidate = false;
            errorList.push("Select Material Name");
            showMessage(errorList, true, 'error');
        }
        //if (Remarks == "" || Remarks === null || Remarks === undefined) {
        //    isValidate = false;
        //    //showMsg(true, "Select Entry Date.", alerterrorclass, alerterror);
        //    errorList.push("Enter Remarks");
        //    showMessage(errorList, true, 'error');
        //}

        if (isValidate) {
            setopenLoader(true);
            let slipData = {
                LocationId: Number(phyInvlocationID),
                MaterialId: Number(phyInvMaterialID),
                CountedPhyQuantity: physical,
                Remarks: Remarks,
                ModifiedBy: props.createdUserId,
                SlipId: props.editData.slipId,
                //CreatedBy: CreatedUserId,
            }
          //  console.log("slipData", slipData);
            //let errorList = [];
            api.post("/UpdatePhyInvSlip/", slipData,{headers: headers})
                .then(res => {
                    //console.log("savedata", res.data);
                    setopenLoader(false);
                    //errorList.push("Entry Number S" + res.data.slipNumber + " submitted successfully.");
                    props.clickgoback(res.data);
                    //showMessage(errorList, true, 'success');
                })
                .catch(error => {
                    setopenLoader(false);
                })
        }
    }
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1"> Update Slip </h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            id="id"
                            disabled={true}
                            label="Slip Number"
                            variant="filled"
                            fullWidth
                            //name="Created Time"
                            value={slipNumber}
                            onChange={handleslipNumber}
                        />
                        
                        
                        
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields  "
                            
                            id=""
                            disabled={true}
                            label="Plant Id"
                            variant="filled"
                            fullWidth
                            name=""
                            value={placeValue}
                            onChange={handlePlace}
                        >
                            
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                        <Autocomplete className="lightInputFields"
                            //disablePortal
                            id="combo-box-demo"
                            value={phyInvlocationObj}
                            inputValue={phyInvlocationName}
                            options={phyInvlocation}
                            getOptionLabel={option => option.locationName ? option.locationName : ""}
                            onChange={handleChangephyInvlocation}
                            onInputChange={handleChangephyInvlocationInput}
                            // sx={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="Location" />}
                        />
                    {/*    <TextField className="lightInputFields  "*/}
                    {/*        //id="CreatedDate"*/}
                    {/*        //disabled={true}*/}
                    {/*        select*/}
                    {/*        label="Location"*/}
                    {/*        variant="filled"*/}
                    {/*        fullWidth*/}
                    {/*        // name="Created Date"*/}
                    {/*        value={loc}*/}
                    {/*        onChange={handleLoc}*/}
                    {/*    >*/}
                    {/*        <MenuItem value="">*/}
                    {/*            <em>Select</em>*/}
                    {/*        </MenuItem>*/}
                    {/*        <MenuItem value={10}>Ten</MenuItem>*/}
                    {/*        <MenuItem value={20}>Twenty</MenuItem>*/}
                    {/*        <MenuItem value={30}>Thirty</MenuItem>*/}
                    {/*    </TextField>*/}
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">
                        <Autocomplete className="lightInputFields"
                            //disablePortal
                            id="combo-box-demo"
                            value={phyInvMaterialObj}
                            inputValue={phyInvMaterialName}
                            options={phyInvMaterial}
                            getOptionLabel={option => option.materialName ? option.materialName : ""}
                            onChange={handleChangephyInvMaterial}
                            onInputChange={handleChangephyInvMaterialInput}
                            // sx={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="Material Number" />}
                        />
                       
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            //id="CreatedTime"
                            disabled={true}
                            label="Material Description"
                            variant="filled"
                            fullWidth
                            //name="Created Time"
                            value={matDesc}
                            onChange={handleMatDesc}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            //id="inputTime"
                            
                            label="Counted Physical Quantity"                           
                            //variant="filled"
                            //fullWidth
                            helperText={canShowHelperText ? "" : "Please enter only numbers from 0 to 1Crore"}
                            // name="Input Time"
                            value={physical}
                            onChange={handlePhysical}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            id="inputTime"
                            disabled={true}
                            label="Entered By User"
                            variant="filled"
                            fullWidth
                            // name="Input Time"
                            value={enteredByUser}
                            onChange={handleEnteredByUser}
                        />
                    </Grid>
                   
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            //id="CreatedTime"
                           disabled={true}
                            label="ABC Classification"
                            variant="filled"
                            fullWidth
                            //name="Created Time"
                            value={classification}
                            onChange={handleClassification}
                        />
                    </Grid>

                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields  "
                            id=""
                            disabled={true}
                            label="Unit Of Measure"
                            variant="filled"
                            fullWidth
                            //name="Entered Time"
                            value={unit}
                            onChange={handleUnit}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            // id="idleTime"
                            disabled={true}
                            label="Date Of Entry"
                            variant="filled"
                            fullWidth
                            //name="Idle/IHF Time"
                            value={dateOfEntry}
                            onChange={handledateOfEntryChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} className="d-flex Width-100 mt-1">
                        <TextField className="lightInputFields"
                            // id="idleTime"
                            //disabled={true}
                            label="Remarks"
                            variant="filled"
                            fullWidth
                            //name="Idle/IHF Time"
                            value={Remarks}
                            onChange={handleRemarksChange}
                        />
                    </Grid>
                   

                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={UpdateSlip} >
                            <span>Update</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={clear} >
                            <span>Clear</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        {/*<Link to={"/ModifyInventory"}>*/}
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={backClick}  >
                            <span>Back</span>
                            </Button>
                    {/*        </Link>*/}
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">
                    </Grid>

                </Grid>

                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>

            </div>
        </ThemeProvider>
    );
}


